import React, { Component } from 'react'
import style from './style.module.less'
import omit from 'lodash/omit'

export default class extends Component {
  render() {
    const { flexStart, required, label } = this.props
    const childrenWithProps = React.Children.map(this.props.children, child => {
      if (child && typeof child === 'object') {
        return React.cloneElement(child, {
          ...omit(this.props, ['flexStart', 'required', 'label', 'children'])
        })
      } else {
        return child
      }
    })
    return (
      <div
        className={style.colums}
        style={{ alignItems: flexStart ? 'flex-start' : 'center' }}
      >
        <div className={style.labelCol}>
          {required && <i className={style.require} />}
          {label}
        </div>
        <div className={style.wrapperCol}>{childrenWithProps}</div>
      </div>
    )
  }
}
